module.exports = __webpack_public_path__ + "static/media/SarahSwitek_01_Introduction_1.1455d551.mp3";